import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { ConfigProvider, Button, Form, Input, Select, Modal, Row, Spin, Col, Empty, Pagination, message } from "antd";
import type { PaginationProps } from "antd";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { publicPath } from "@/utils/base";
import { appNameReg, packageNameReg } from "@/utils/constant";
import { getReleaseDetail } from "@/utils";
import SelectWithAll from "@/components/SelectWithAll";
import api from "@/api";

import "./index.less";

import dataJson from "@/../public/data.json";
import { cloneDeep } from "lodash-es";
const prefix = "protocolPlugin";

function protocolPlugin() {
  const { app_list, req_err, create, two_bars, app_detail, release, add_create } = dataJson;
  const typeObj: any = app_detail.type_obj;
  const filterFormJson = app_list.filter_form;
  const addFormJson = app_list.add_form;

  // const [insider, setInsider] = useState<boolean | null>(null); //是否内部人员：true是，false不是
  const [addOpen, setAddOpen] = useState(false);
  const [addOpenLoading, setAddFormLoading] = useState(false);
  const [pageData, setPageData] = useState<any[]>([]);
  const [total, setTotal] = useState<number>(0);
  const [loading, setLoading] = useState(false);
  const typeFilterItem = useRef<any>({});

  const [filterForm] = Form.useForm();

  const [addForm] = Form.useForm();

  const navigate = useNavigate();
  const userData = useSelector((state: any) => state.userData);

  const pageInit = {
    pageSize: 20,
    pageNo: 1,
  };
  const pageNo = useRef<number>(pageInit.pageNo);
  const pagesize = useRef<number>(pageInit.pageSize);

  const onFilter = () => {
    pageNo.current = pageInit.pageNo;
    pagesize.current = pageInit.pageSize;
    getPageData();
  };

  const onShowSizeChange: PaginationProps["onShowSizeChange"] = (current, pageSize) => {
    pagesize.current = pageSize;
  };

  const getPageData = async () => {
    try {
      setLoading(true);
      const filterFormValues = await filterForm.getFieldsValue();
      typeFilterItem.current = typeObj[filterFormValues?.type];

      const res: any = await api.getAllPage({
        page: pageNo.current,
        limit: pagesize.current,
        keyword: filterFormValues.name,
        typeKeys: filterFormValues.type || ["PSO"],
        showModes: filterFormValues.status,
      });
      if (res.code === 200) {
        const dataCopy = cloneDeep(res.data.datas);
        const list = dataCopy.map((item: any) => {
          item.iconImg = item?.resources?.find((ele: any) => ele.type == "ICON")?.url;
          const showModeItem = release.show_mode_arr?.find((ele: any) => ele.value === item.showMode);

          item.title = showModeItem?.title;
          item.textColor = showModeItem?.textColor;
          item.bgColor = showModeItem?.bgColor;
          item.typeLable = typeObj[item.typeKey]?.label;
          item.typeBgColor = typeObj[item.typeKey]?.bgColor;
          return item;
        });

        setPageData(list);
        setTotal(Number(res?.data?.total));
        setLoading(false);
      } else {
        setLoading(false);
        message.error(res.msg || req_err);
      }
    } catch (errorInfo: any) {
      console.error(errorInfo);
      setPageData([]);
      setTotal(0);
      setLoading(false);
    }
  };

  const validateName = (_: any, value: any) => {
    if (value) {
      return api.psoRepeatName({ name: value }).then((resp: any) => {
        if (resp.code === 200) {
          if (resp.data?.exist) {
            return Promise.reject(new Error(app_list.name_already));
          }
        } else {
          return Promise.resolve();
        }
      });
    } else {
      return Promise.resolve();
    }
  };

  const validatePackageName = (_: any, value: any) => {
    if (value) {
      return api.psoRepeatPackageName({ packageName: value }).then((resp: any) => {
        if (resp.code === 200) {
          if (resp.data?.exist) {
            return Promise.reject(new Error(app_list.packagename_already));
          }
        } else {
          return Promise.resolve();
        }
      });
    } else {
      return Promise.resolve();
    }
  };

  const showAddModal = () => {
    setAddOpen(true);
  };
  const handleAddOpenOk = async () => {
    try {
      const values = await addForm.validateFields();
      setAddFormLoading(true);
      const res: any = await api.psoAdd({
        name: values.name,
        packageName: values.packageName,
        subType: ["ZIP"],
        type: "PSO",
      });
      if (res.code === 200) {
        message.success(app_list.creat_success);
        setAddOpen(false);
        navigate(`${publicPath}/app_detail/info/PSO/${res.data.id}`);
      } else {
        setAddFormLoading(false);
        message.error(res.msg || req_err);
      }
    } catch (errorInfo: any) {
      setAddFormLoading(false);
    }
  };

  const handleAddCancel = () => {
    setAddOpen(false);
  };

  const clickCard = (item: any) => {
    getReleaseDetail(item.typeKey, item.id, () => {
      // navigate(`${publicPath}/protocol_plugin_detail/info/${item.id}`);
      navigate(`${publicPath}/app_detail/info/${item.typeKey}/${item.id}`);
    });
  };

  useEffect(() => {
    if (JSON.stringify(userData) !== "{}") {
      getPageData();
    }
  }, [userData]);

  return (
    <div className={prefix}>
      <div className={`${prefix}-top`}>
        <Form
          form={filterForm}
          layout="inline"
          initialValues={{
            status: filterFormJson.status_options.map((item) => item.value),
          }}
        >
          <Form.Item
            name="name"
            getValueFromEvent={(e) => e.target.value.replace(/(^\s*)|(\s*$)/g, "")}
            style={{ marginRight: 56 }}
          >
            <Input
              placeholder={filterFormJson.name_placeholder}
              onPressEnter={onFilter}
              maxLength={150}
              style={{ width: 296 }}
            />
          </Form.Item>
          <Form.Item name="status" label={filterFormJson.status_label}>
            <SelectWithAll
              options={filterFormJson.status_options}
              placeholder={filterFormJson.status_placeholder}
              onChange={onFilter}
              style={{ width: 296 }}
              value={filterForm.getFieldValue("status")}
            />
          </Form.Item>
        </Form>
        <ConfigProvider
          theme={{
            components: {
              Button: {
                borderRadius: 0,
                paddingInline: 40,
                paddingBlock: 8,
              },
            },
          }}
        >
          <Button type="primary" onClick={showAddModal}>
            新建
          </Button>
        </ConfigProvider>
      </div>
      <Spin spinning={loading} size="large" wrapperClassName={`${prefix}-spin`}>
        {total === 0 ? (
          <Empty />
        ) : (
          <div className={`${prefix}-content`}>
            {pageData.map((item: any) => {
              return (
                <div
                  key={item.id}
                  onClick={() => {
                    clickCard(item);
                  }}
                  className={`${prefix}-content-item`}
                >
                  <div
                    className={`${prefix}-content-status`}
                    style={{ color: item?.textColor, backgroundColor: item?.bgColor }}
                  >
                    {item.title}
                  </div>
                  <div className={`${prefix}-content-type`} style={{ backgroundColor: item?.typeBgColor }}>
                    {item.typeLable}
                  </div>
                  <div className={`${prefix}-content-inner`}>
                    <img src={item?.iconImg ? item?.iconImg : app_list.init_img} alt="" />
                    <div>
                      <div title={item?.name} className={`${prefix}-content-title one-line-ellipsis`}>
                        {item?.name || two_bars}
                      </div>
                      <div>{app_detail.package_name}</div>
                      <div title={item?.packageName || ""} className={`${prefix}-content-package two-line-ellipsis`}>
                        {item?.packageName || two_bars}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </Spin>
      <Pagination
        pageSize={pagesize.current}
        current={pageNo.current}
        total={total}
        showSizeChanger
        showQuickJumper
        showTotal={(total) => `共 ${total} 条`}
        align="end"
        className={`${prefix}_page`}
        onShowSizeChange={onShowSizeChange}
        onChange={(page: number) => {
          pageNo.current = page;
          getPageData();
        }}
      />
      <Modal
        title={create}
        centered
        destroyOnClose
        confirmLoading={addOpenLoading}
        open={addOpen}
        okText={add_create}
        onOk={handleAddOpenOk}
        onCancel={handleAddCancel}
        width={328}
      >
        <Form form={addForm} layout="vertical" clearOnDestroy>
          <Form.Item
            name="name"
            label={addFormJson.name_label}
            validateDebounce={500}
            rules={[
              { required: true, message: addFormJson.name_placeholder },
              {
                pattern: appNameReg,
                message: app_detail.name_validator,
              },
              { validator: validateName },
            ]}
            getValueFromEvent={(e) => e.target.value.replace(/(^\s*)|(\s*$)/g, "")}
          >
            <Input showCount maxLength={30} placeholder={addFormJson.name_placeholder} />
          </Form.Item>
          <Form.Item
            name="packageName"
            label={addFormJson.packageName_label}
            validateDebounce={500}
            rules={[
              { required: true, message: addFormJson.packageName_placeholder },
              {
                pattern: packageNameReg,
                message: app_detail.package_name_validator,
              },
              { validator: validatePackageName },
            ]}
            getValueFromEvent={(e) => e.target.value.replace(/(^\s*)|(\s*$)/g, "")}
          >
            <Input showCount maxLength={127} placeholder={addFormJson.packageName_placeholder} />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
}

export default protocolPlugin;
